<template>
  <jc-dialog
    :title="$t('禁用代金券')"
    :visible.sync="disableShow"
    @close="resetForm('disableCoupon')"
    :modal-append-to-body="false"
    :close-on-click-modal="false"
    size="tiny"
  >
    <jc-form label-width="120px" ref="disableCoupon" :model="disableForm" :rules="disableRules">
      <jc-form-item :label="$t('禁用原因：')" prop="disableReason">
        <jc-input
          type="textarea"
          v-model.trim="disableForm.disableReason"
          :maxlength="500"
          :rows="4"
        ></jc-input>
      </jc-form-item>
    </jc-form>
    <span slot="footer" class="dialog-footer">
      <jc-button type="primary" class="dialogDisable" @click="disableCoupon">{{$t('确定')}}</jc-button>
      <jc-button @click="disableShow = false">{{$t('关闭')}}</jc-button>
    </span>
  </jc-dialog>
</template>
<script>
export default {
  name: 'basicForm',
  props: ['couponNumber'],
  data() {
    return {
      disableShow: false,
      disableForm: {
        disableReason: ''
      },
      disableRules: {
        disableReason: [
          { required: true, message: '请输入禁用原因', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    async disableCoupon() {
      this.$refs['disableCoupon'].validate(async valid => {
        if (valid) {
          this.$emit('submit', this.disableForm.disableReason)
        } else {
          console.log('err')
        }
      })
    },
    resetForm(ruleForm) {
      setTimeout(() => {
        this.$refs[ruleForm].resetFields()
      }, 10)
    }
  }
}
</script>
